import type {BioIconProps} from '../../icons/common-types'

export default function BestSportsGearPicksLogo({className, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo flex w-fit items-center gap-1 text-2xl font-semibold text-white tablet:gap-0 tablet:text-base">
      <svg width="49" height="32" viewBox="0 0 49 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <circle cx="24.5858" cy="14.358" r="14.358" fill="white" fillOpacity="0.16" />
        <rect x="16.5218" y="16.1282" width="16.1282" height="6.29391" stroke="white" strokeWidth="0.786739" />
        <rect
          x="32.6314"
          y="10.6209"
          width="7.88583"
          height="17.5787"
          rx="1.18011"
          stroke="white"
          strokeWidth="0.786739"
        />
        <rect
          x="8.65429"
          y="10.6209"
          width="7.88583"
          height="17.5787"
          rx="1.18011"
          stroke="white"
          strokeWidth="0.786739"
        />
      </svg>
      <span>Best Sport Gear Picks</span>
    </div>
  )
}
